module.exports = __webpack_public_path__ + "static/media/picasso-9.31fe591f.jpeg";